import { apiAuthUrl, apiCallback, apiCheckCorpAuthoer, apiCompanyAuthor, apiLogin, ReqLogin } from "@/api";
import router from "@/router";
import { env, useMainStore, useStore } from "@/store";
import { getQueryVariable } from "@/utils";
import { showConfirmDialog } from "vant";
import { ref, reactive } from "vue";
export default () => {
  const store = useStore();
  const obj: any = getQueryVariable();
  console.log(obj, "obj");
  store.setCorpId(obj.corpId);
  const form = reactive<ReqLogin>({
    serial: "",
    name: "",
    pwd: "",
  });
  const isAuthorize = ref(false);
  const login = async (o: ReqLogin) => {
    const params = { ...o, corpId: obj.corpId };
    try {
      store.setLoading(true);
      if (isAuthorize.value) {
        const { data } = await apiLogin(params);
        store.setIsLogout(false);
        window.open(data, "_self");
      } else {
        await apiCompanyAuthor(params);
        store.setLoading(false);
        try {
          await showConfirmDialog({ message: `是否继续使用该账号登录${env.VITE_APP_COMPANY}\n会将该微信与该账号关联`, confirmButtonText: "是", cancelButtonText: "否" });
          isAuthorize.value = true;
          login(o);
        } catch {
          isAuthorize.value = true;
          form.serial = "";
          form.name = "";
          form.pwd = "";
        }
      }
    } finally {
      store.setLoading(false);
    }
  };

  const check = async () => {
    try {
      store.setLoading(true);
      const codes: string[] = JSON.parse(localStorage.getItem("codes") || "[]") || [];
      if (obj.iscode == "ydz" && obj.code && !codes.includes(obj.code)) {
        localStorage.setItem("codes", JSON.stringify([...codes, obj.code]));
        isAuthorize.value = true;
        const { data } = await apiCallback(obj);
        window.open(location.href.split("&code")[0], "_self");
        localStorage.removeItem("codes");

        store.setUserinfo(data);
        router.replace({ name: "main", params: { type: "home" } });
      } else {
        const { data } = await apiAuthUrl(obj.corpId);
        if (data) window.open(data, "_self");
        else {
          const { message } = await apiCheckCorpAuthoer({ corpId: obj.corpId });
          isAuthorize.value = message == "已授权";
        }
      }
    } finally {
      store.setLoading(false);
    }
  };

  check();

  return {
    form,
    login,
    isAuthorize,
  };
};

export let isWatch = true;
export const setIsWatch = (v: boolean) => {
  isWatch = v;
};

export const logout = () => {
  const codes = localStorage.getItem("codes") || "[]";
  localStorage.clear();
  localStorage.setItem("codes", codes);
  sessionStorage.clear();
  setIsWatch(false);
  useStore().$reset();
  useMainStore().$reset();
  useStore().setIsLogout(true);
  router.replace({ name: "login" });
  setTimeout(() => {
    setIsWatch(true);
  }, 0);
};
